module.exports = __webpack_public_path__ + "static/img/4.915334e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.png
// module id = +TIe
// module chunks = 1